import { useQuery } from '@tanstack/react-query';
import { fetchProjectName } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useProjectName = () =>
  useQuery({
    queryFn: () => extractData(fetchProjectName()),
    queryKey: [''],
    select: (data) => data.projectName,
  });
